// /src/services/CustomAPIService.js
import axios from 'axios'
import map from 'lodash/map'
import defaults from 'lodash/defaults'
import assign from 'lodash/assign'
// import { uStore } from '@/services/Storage'

const defaultOptions = {
  // per_page: 100,
}

const customAPI = axios.create({
  baseURL: `/wp-json/carr/v1/`,
  timeout: 60000,
})

customAPI.interceptors.request.use(request => requestHandler(request))
customAPI.interceptors.response.use(response => responseHandler(response))

export const requestHandler = request => {
  if (isHandlerEnabled(request)) {
    request.headers['Accept'] = 'application/json'
  }
  return request
}

export const responseHandler = response => {
  // if (response.status == 200) {
    return response
  // } 
}

const isHandlerEnabled = (config = {}) => {
  return 'handlerEnabled' in config && !config.handlerEnabled ? false : true
}

//  makes url query parameter string
export const mkArgStr = function(argOptions = {}) {
  return map(argOptions, (val, key) => {
    if (val == true) {
      return `${key}`
    } else {
      return `${key}=${val}`
    }
  }).join('&')
}
// id required to keep from overwriting other posts
// meta_key required to ensure data stored under proper key
export const mkPostArgStr = function(post = {}) {
  const { id, type, stringValue } = post
  if (stringValue) {
    return `?${type}=${stringValue}`
  } else if (id && type) {
    return (
      '?' +
      map(post, (val, key) => {
        if (typeof val == 'object' && Object.keys(val).length > 0) {
          val = map(val, (value, prop) => `${prop}=${value}`).join('|')
        }
        return `${type}[${key}]=${val}`
      }).join('&')
    )
  }
  return ''
}

// merge args allows overriding of defaults
export const mergeArgs = function(argOptions = {}) {
  return defaults(argOptions, defaultOptions)
}

// merges default args then makes url query parameter string
export const mkParamStr = function(argOptions = {}) {
  const args = defaults(argOptions, defaultOptions)
  return Object.keys(args).length > 0 ? '?' + mkArgStr(args) : ''
}

export const futureDate = function(timestamp, requestInterval = 3) {
  return timestamp + requestInterval * 60000
}

export const apiPost = async function(endpoint, post = {}) {
  const postObjStr = mkPostArgStr(post)
  try {
    return await customAPI.put(`${endpoint}${postObjStr}`)
  } catch (err) {
    console.log(err)
    return err.response
  }
}

export const setJWTinAPI = function(token) {
  customAPI.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export const apiGet = async function(endpoint, paramOptions = {}) {
  // creation of new Object args keeps params from heading up the foodchain.
  const args = assign({}, paramOptions)
  try {
    const response = await getPage(endpoint, args)
    const totalPages = response.headers['x-wp-totalpages']
    if (totalPages > 1) {
      const totalP = range(totalPages)
      if (response.data) {
        response.data.push(
          // ...(await Promise.all(
            await Object.keys(totalP).map(async key => {
              args['page'] = totalP[key]
              const { data } = await getPage(endpoint, args)
              return data
            }),
          // )),
        )
        response['data'] = response.data.flat()
        return response
      }
    } else {
      return response
    }
  } catch (err) {
    return err
  }
}

export const getCustomAPIPage = function(endpoint, paramOptions = {}) {
  try {
    const argsStr = mkParamStr(paramOptions)
    return customAPI.get(`${endpoint}${argsStr}`)
  } catch (err) {
    return err
  }
}

export default customAPI

function range(size, startAt = 2) {
  return Array(size - startAt + 1)
    .fill()
    .map((_, idx) => startAt + idx)
}
